export const currencies = {
  usd: { value: "USD", label: "USD - US Dollar" },
  eur: { value: "EUR", label: "EUR - Euro" },
  pln: { value: "PLN", label: "PLN - Polish Zloty" },
  aud: { value: "AUD", label: "AUD - Australian Dollar" },
  aed: { value: "AED", label: "AED - Emirati Dirham" },
  bgn: { value: "BGN", label: "BGN - Bulgarian Lev" },
  bhd: { value: "BHD", label: "BHD - Bahraini Dinar" },
  brl: { value: "BRL", label: "BRL - Brazilian Real" },
  cad: { value: "CAD", label: "CAD - Canadian Dollar" },
  chf: { value: "CHF", label: "CHF - Swiss Franc" },
  cny: { value: "CNY", label: "CNY - Chinese Yuan" },
  czk: { value: "CZK", label: "CZK - Czech Koruna" },
  dkk: { value: "DKK", label: "DKK - Danish Krone" },
  dzd: { value: "DZD", label: "DZD - Algerian Dinar" },
  egp: { value: "EGP", label: "EGP - Egyptian Pound" },
  gbp: { value: "GBP", label: "GBP - British Pound" },
  hkd: { value: "HKD", label: "HKD - Hong Kong Dollar" },
  hrk: { value: "HRK", label: "HRK - Croatian Kuna" },
  huf: { value: "HUF", label: "HUF - Hungarian Forint" },
  idr: { value: "IDR", label: "IDR - Indonesian Rupiah" },
  ils: { value: "ILS", label: "ILS - Israeli New Shekel" },
  inr: { value: "INR", label: "INR - Indian Rupee" },
  iqd: { value: "IQD", label: "IQD - Iraqi’s Dinar" },
  jod: { value: "JOD", label: "JOD - Jordanian Dinar" },
  jpy: { value: "JPY", label: "JPY - Japanese Yen" },
  krw: { value: "KRW", label: "KRW - South Korean Won" },
  kwd: { value: "KWD", label: "KWD - Kuwaiti Dinar" },
  lkr: { value: "LKR", label: "LKR - Sri Lankan Rupee" },
  MAD: { value: "MAD", label: "MAD - Moroccan Dirham" },
  mvr: { value: "MVR", label: "MVR - Maldivian Rufiyaa" },
  mxn: { value: "MXN", label: "MXN - Mexican Peso" },
  myr: { value: "MYR", label: "MYR - Malaysian Ringgit" },
  nok: { value: "NOK", label: "NOK - Norwegian Krone" },
  nzd: { value: "NZD", label: "NZD - New Zealand Dollar (NZ$)" },
  omr: { value: "OMR", label: "OMR - Omani Rial" },
  php: { value: "PHP", label: "PHP - Philippine Peso" },
  ron: { value: "RON", label: "RON - Romanian Leu" },
  rub: { value: "RUB", label: "RUB - Russian Ruble" },
  sar: { value: "SAR", label: "SAR - Saudi Arabian Riyal" },
  sek: { value: "SEK", label: "SEK - Swedish Krona" },
  sgd: { value: "SGD", label: "SGD - Singapore Dollar" },
  thb: { value: "THB", label: "THB - Thai Baht" },
  try: { value: "TRY", label: "TRY - Turkish Lira" },
  twd: { value: "TWD", label: "TWD - Taiwan Dolar" },
  TND: { value: "TND", label: "TND - Tunisian Dinar" },
  vnd: { value: "VND", label: "VND - Vietnamese Dong" },
  zar: { value: "ZAR", label: "ZAR - South African Rand" },
};

export const currenciesList = Object.keys(currencies);
